import { render, staticRenderFns } from "./plugin-update.vue?vue&type=template&id=739b6291&scoped=true&"
import script from "./plugin-update.vue?vue&type=script&lang=js&"
export * from "./plugin-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b6291",
  null
  
)

export default component.exports